{
  "metadata": {
    "id": "everforest-light",
    "name": "Everforest",
    "description": "Портировано из темы «Everforest» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "everforest.json",
      "project": "sainnhe",
      "url": "https://github.com/sainnhe/everforest",
      "upstreamFile": "packages/ui/src/theme/themes/everforest.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.456,
      "paletteMaxS": 0.515,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.9,
      "syntaxVsTextMinDeltaE": 16.0,
      "chartsMinDeltaE": 22.8,
      "textSeparationDeltaE": 10.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#849701",
      "hover": "#778801",
      "active": "#6c7c01",
      "foreground": "#000000",
      "muted": "#84970180",
      "emphasis": "#849701"
    },
    "surface": {
      "background": "#fdf6e3",
      "foreground": "#3f494e",
      "muted": "#cbcbc1",
      "mutedForeground": "#41493d",
      "elevated": "#b3b6b0",
      "elevatedForeground": "#3e484d",
      "raised": "#959c9b",
      "raisedForeground": "#2c3337",
      "overlay": "#fdf6e333",
      "subtle": "#e4e0d2"
    },
    "interactive": {
      "border": "#8c9495",
      "borderHover": "#c5c4b5",
      "borderFocus": "#849701",
      "selection": "#5c6a7224",
      "selectionForeground": "#5c6a72",
      "focus": "#84970159",
      "focusRing": "#84970147",
      "cursor": "#5c6a72",
      "hover": "#5c6a7217",
      "active": "#5c6a7224"
    },
    "status": {
      "error": "#e00d09",
      "errorForeground": "#ffffff",
      "errorBackground": "#e00d091a",
      "errorBorder": "#e00d0959",
      "warning": "#b75208",
      "warningForeground": "#ffffff",
      "warningBackground": "#b752081a",
      "warningBorder": "#b7520859",
      "success": "#697801",
      "successForeground": "#ffffff",
      "successBackground": "#6978011a",
      "successBorder": "#69780159",
      "info": "#277c5c",
      "infoForeground": "#ffffff",
      "infoBackground": "#277c5c1a",
      "infoBorder": "#277c5c59"
    },
    "pr": {
      "open": "#697801",
      "draft": "#4d5648",
      "blocked": "#b75208",
      "merged": "#dd61b6",
      "closed": "#e00d09"
    },
    "syntax": {
      "base": {
        "background": "#cbcbc1",
        "foreground": "#5c6a72",
        "comment": "#4d5648",
        "keyword": "#992173",
        "string": "#4f5a01",
        "number": "#8b3e06",
        "function": "#1e5d45",
        "variable": "#aa0a07",
        "type": "#6f4f00",
        "operator": "#1e5d45"
      },
      "tokens": {
        "commentDoc": "#4d5648",
        "stringEscape": "#1e5d45",
        "keywordImport": "#992173",
        "storageModifier": "#992173",
        "functionCall": "#1e5d45",
        "method": "#1e5d45",
        "variableProperty": "#1e5d45",
        "variableOther": "#aa0a07",
        "variableGlobal": "#8b3e06",
        "variableLocal": "#1e5d45",
        "parameter": "#aa0a07",
        "constant": "#8b3e06",
        "class": "#6f4f00",
        "className": "#6f4f00",
        "interface": "#6f4f00",
        "struct": "#6f4f00",
        "enum": "#6f4f00",
        "typeParameter": "#6f4f00",
        "namespace": "#6f4f00",
        "module": "#992173",
        "tag": "#992173",
        "jsxTag": "#992173",
        "tagAttribute": "#1e5d45",
        "tagAttributeValue": "#4f5a01",
        "boolean": "#8b3e06",
        "decorator": "#992173",
        "label": "#1e5d45",
        "regexp": "#4f5a01"
      }
    },
    "charts": {
      "series": [
        "#849701",
        "#277c5c",
        "#417801",
        "#b75208",
        "#e00d09"
      ]
    },
    "chat": {
      "background": "#fdf6e3",
      "userMessage": "#3e484d",
      "userMessageBackground": "#b3b6b0",
      "assistantMessage": "#4a555b",
      "assistantMessageBackground": "#cbcbc1",
      "timestamp": "#4d5648",
      "divider": "#8c9495",
      "typing": "#4d5648"
    },
    "loading": {
      "spinner": "#849701",
      "spinnerTrack": "#cbcbc1",
      "skeleton": "#cbcbc1",
      "shimmer": "#c4c5bc"
    },
    "tools": {
      "background": "#cbcbc1",
      "border": "#8c9495",
      "headerHover": "#c5c6bd",
      "icon": "#657401",
      "title": "#5c6a72",
      "description": "#4d5648",
      "edit": {
        "added": "#697801",
        "addedBackground": "#6978011a",
        "removed": "#e00d09",
        "removedBackground": "#e00d091a",
        "modified": "#277c5c",
        "modifiedBackground": "#277c5c1a",
        "lineNumber": "#4d5648"
      }
    },
    "markdown": {
      "heading1": "#5c6a72",
      "heading2": "#5c6a72",
      "heading3": "#5c6a72",
      "heading4": "#5c6a72",
      "link": "#657401",
      "linkHover": "#657401",
      "inlineCode": "#4f5a01",
      "inlineCodeBackground": "#cbcbc1",
      "blockquote": "#4d5648",
      "blockquoteBorder": "#8c9495",
      "listMarker": "#809201",
      "bold": "#5c6a72",
      "italic": "#5c6a72e6",
      "strikethrough": "#4d5648",
      "hr": "#8c9495"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a3c37",
        "foreground": "#ffffff",
        "contrast": 7.55
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c77d57",
        "foreground": "#000000",
        "contrast": 6.5
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#caa85d",
        "foreground": "#000000",
        "contrast": 9.27
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b6cd63",
        "foreground": "#000000",
        "contrast": 11.9
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#6a8f42",
        "foreground": "#000000",
        "contrast": 5.62
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#65cb5f",
        "foreground": "#000000",
        "contrast": 10.26
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#62cb90",
        "foreground": "#000000",
        "contrast": 10.46
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e6f",
        "foreground": "#000000",
        "contrast": 5.34
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#64ccc6",
        "foreground": "#000000",
        "contrast": 10.99
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3e788c",
        "foreground": "#ffffff",
        "contrast": 4.92
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b80bb",
        "foreground": "#000000",
        "contrast": 5.25
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#323685",
        "foreground": "#ffffff",
        "contrast": 10.49
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8053c1",
        "foreground": "#ffffff",
        "contrast": 5.35
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c658be",
        "foreground": "#000000",
        "contrast": 5.54
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b7a",
        "foreground": "#ffffff",
        "contrast": 7.03
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c55678",
        "foreground": "#000000",
        "contrast": 4.98
      }
    ]
  }
}
